import React, { useEffect, useRef, useState } from 'react';

// Frame owns the entry fade + hover/select lift. Clicking the card (not a button/link)
// selects it; only one card stays selected at a time (broadcast via a window event).
export const ServiceCard = ({ children, testId, className = '', delay = 0 }) => {
  const [selected, setSelected] = useState(false);
  const idRef = useRef(Symbol('service-card'));

  useEffect(() => {
    const handler = (e) => setSelected(e.detail === idRef.current);
    window.addEventListener('service-card-select', handler);
    return () => window.removeEventListener('service-card-select', handler);
  }, []);

  const onClick = (e) => {
    if (e.target.closest('button, a, input, [role="button"]')) return;
    const next = selected ? null : idRef.current;
    window.dispatchEvent(new CustomEvent('service-card-select', { detail: next }));
  };

  return (
    <div
      className={`service-card-frame ${selected ? 'selected' : ''} ${className}`}
      style={{ '--entry-delay': `${delay}ms` }}
      data-testid={`${testId}-frame`}
      onClick={onClick}
    >
      {React.cloneElement(children, {
        className: `${children.props.className} service-card-surface`,
      })}
      <span className="service-card-ring" aria-hidden="true">
        <span className="service-card-beam" />
      </span>
    </div>
  );
};
